import React from "react";
import styled from "styled-components";
import { DatePicker } from "Components/Base/Inputs/DatePicker";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { Box } from "Components/Base/Layout/Box";

const StyledMUIInputLabelDatePicker = styled.div``;

const StyledOldLabel = styled.label`
  margin: 0 0 4px 0;
`;

const InputLabelDatePicker = ({
  id,
  label = false,
  name = "",
  required,
  value,
  min,
  max,
  placeholder,
  disabled = false,
  onChange = () => {},
  onFocus = () => {},
  oldStyleLabel = false,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      {oldStyleLabel && (
        <StyledOldLabel className={required ? "required" : ""} htmlFor={id}>
          {label}:
        </StyledOldLabel>
      )}
      {!oldStyleLabel && (
        <Box mb={1} width="fit-content">
          <InputLabel className={required ? "required" : ""} htmlFor={id}>
            {label}
          </InputLabel>
        </Box>
      )}
      <DatePicker
        id={id}
        name={name}
        value={value}
        {...(required ? { required: true } : "")}
        placeholder={placeholder}
        {...(disabled && disabled)}
        {...(min && { min })}
        {...(max && { max })}
        onChange={onChange}
        onFocus={onFocus}
      />
    </Box>
  );
};

export default InputLabelDatePicker;
